<div class="ios-switch" [class.active]="value" [class.disabled]="disabled" (click)="onSwitcherToggle()">
  <span class="switch-body">
    <span class="toggle"></span>
  </span>
  <input type="checkbox" name="switcher">
</div>
